import "./index.scss";

import { Box, Stack } from "@mui/material";
import RatingBar from "components/RatingBar";
import { Controller, useFormContext } from "react-hook-form";

const REMS = (props: { currentTab: string }) => {
  const { currentTab } = props;
  const formContext = useFormContext();
  const {
    control,
    formState: { errors },
  } = formContext;

  if (currentTab !== "rems") return null;
  return (
    <Box className="tcaRems">
      <h3>
        This assessment is a set of questions we use to best tailor an exercise plan and support
        methods based on you as a unique person. Please fill in the most correct response (1-5)
        based on how the corresponding item describes you. There are no right or wrong answers and
        your answers will be kept strictly confidential.
      </h3>
      <Box className="ratingLegend">Strongly Disagree(1)&mdash;Strongly Agree(5)</Box>
      <Box className="rowQuestionBox">
        <Stack direction={"row"} alignItems="center">
          <Box flexGrow={1}>1. Regular physical activity makes me feel better.</Box>
          <Box>
            <Controller
              name="remsQ1"
              control={control}
              rules={{ required: true }}
              render={({ field: { onChange, value, ref } }) => (
                <Stack spacing={1} flexGrow={1}>
                  <RatingBar value={value} onChange={onChange} />
                  {errors.remsQ1?.type === "required" && (
                    <h4 className="error">This field is required</h4>
                  )}
                </Stack>
              )}
            />
          </Box>
        </Stack>
      </Box>
      <Box className="rowQuestionBox">
        <Stack direction={"row"} alignItems="center">
          <Box flexGrow={1}>2. I've never been a person who sets clear goals.</Box>
          <Box>
            <Controller
              name="remsQ2"
              control={control}
              rules={{ required: true }}
              render={({ field: { onChange, value, ref } }) => (
                <Stack spacing={1} flexGrow={1}>
                  <RatingBar value={value} onChange={onChange} />
                  {errors.remsQ2?.type === "required" && (
                    <h4 className="error">This field is required</h4>
                  )}
                </Stack>
              )}
            />
          </Box>
        </Stack>
      </Box>
      <Box className="rowQuestionBox">
        <Stack direction={"row"} alignItems="center">
          <Box flexGrow={1}>3. My friends support my interests and efforts.</Box>
          <Box>
            <Controller
              name="remsQ3"
              control={control}
              rules={{ required: true }}
              render={({ field: { onChange, value, ref } }) => (
                <Stack spacing={1} flexGrow={1}>
                  <RatingBar value={value} onChange={onChange} />
                  {errors.remsQ3?.type === "required" && (
                    <h4 className="error">This field is required</h4>
                  )}
                </Stack>
              )}
            />
          </Box>
        </Stack>
      </Box>
      <Box className="rowQuestionBox">
        <Stack direction={"row"} alignItems="center">
          <Box flexGrow={1}>
            4. I believe that regular physical activity is needed for good health.
          </Box>
          <Box>
            <Controller
              name="remsQ4"
              control={control}
              rules={{ required: true }}
              render={({ field: { onChange, value, ref } }) => (
                <Stack spacing={1} flexGrow={1}>
                  <RatingBar value={value} onChange={onChange} />
                  {errors.remsQ4?.type === "required" && (
                    <h4 className="error">This field is required</h4>
                  )}
                </Stack>
              )}
            />
          </Box>
        </Stack>
      </Box>
      <Box className="rowQuestionBox">
        <Stack direction={"row"} alignItems="center">
          <Box flexGrow={1}>5. When physical activities get stressful, I stop them.</Box>
          <Box>
            <Controller
              name="remsQ5"
              control={control}
              rules={{ required: true }}
              render={({ field: { onChange, value, ref } }) => (
                <Stack spacing={1} flexGrow={1}>
                  <RatingBar value={value} onChange={onChange} />
                  {errors.remsQ5?.type === "required" && (
                    <h4 className="error">This field is required</h4>
                  )}
                </Stack>
              )}
            />
          </Box>
        </Stack>
      </Box>
      <Box className="rowQuestionBox">
        <Stack direction={"row"} alignItems="center">
          <Box flexGrow={1}>6. I'm good at applying myself to new tasks.</Box>
          <Box>
            <Controller
              name="remsQ6"
              control={control}
              rules={{ required: true }}
              render={({ field: { onChange, value, ref } }) => (
                <Stack spacing={1} flexGrow={1}>
                  <RatingBar value={value} onChange={onChange} />
                  {errors.remsQ6?.type === "required" && (
                    <h4 className="error">This field is required</h4>
                  )}
                </Stack>
              )}
            />
          </Box>
        </Stack>
      </Box>
      <Box className="rowQuestionBox">
        <Stack direction={"row"} alignItems="center">
          <Box flexGrow={1}>7. Physical exertion is rarely enjoyable for me.</Box>
          <Box>
            <Controller
              name="remsQ7"
              control={control}
              rules={{ required: true }}
              render={({ field: { onChange, value, ref } }) => (
                <Stack spacing={1} flexGrow={1}>
                  <RatingBar value={value} onChange={onChange} />
                  {errors.remsQ7?.type === "required" && (
                    <h4 className="error">This field is required</h4>
                  )}
                </Stack>
              )}
            />
          </Box>
        </Stack>
      </Box>
      <Box className="rowQuestionBox">
        <Stack direction={"row"} alignItems="center">
          <Box flexGrow={1}>8. My family members support my interests and efforts.</Box>
          <Box>
            <Controller
              name="remsQ8"
              control={control}
              rules={{ required: true }}
              render={({ field: { onChange, value, ref } }) => (
                <Stack spacing={1} flexGrow={1}>
                  <RatingBar value={value} onChange={onChange} />
                  {errors.remsQ8?.type === "required" && (
                    <h4 className="error">This field is required</h4>
                  )}
                </Stack>
              )}
            />
          </Box>
        </Stack>
      </Box>
      <Box className="rowQuestionBox">
        <Stack direction={"row"} alignItems="center">
          <Box flexGrow={1}>
            9. I can persist when a task is tiring, uncomfortable, and/or painful.
          </Box>
          <Box>
            <Controller
              name="remsQ9"
              control={control}
              rules={{ required: true }}
              render={({ field: { onChange, value, ref } }) => (
                <Stack spacing={1} flexGrow={1}>
                  <RatingBar value={value} onChange={onChange} />
                  {errors.remsQ9?.type === "required" && (
                    <h4 className="error">This field is required</h4>
                  )}
                </Stack>
              )}
            />
          </Box>
        </Stack>
      </Box>
      <Box className="rowQuestionBox">
        <Stack direction={"row"} alignItems="center">
          <Box flexGrow={1}>10. I am responsible for my own success.</Box>
          <Box>
            <Controller
              name="remsQ10"
              control={control}
              rules={{ required: true }}
              render={({ field: { onChange, value, ref } }) => (
                <Stack spacing={1} flexGrow={1}>
                  <RatingBar value={value} onChange={onChange} />
                  {errors.remsQ10?.type === "required" && (
                    <h4 className="error">This field is required</h4>
                  )}
                </Stack>
              )}
            />
          </Box>
        </Stack>
      </Box>
      <Box className="rowQuestionBox">
        <Stack direction={"row"} alignItems="center">
          <Box flexGrow={1}>
            11. I find it difficult using "self-control" to keep myself successful.
          </Box>
          <Box>
            <Controller
              name="remsQ11"
              control={control}
              rules={{ required: true }}
              render={({ field: { onChange, value, ref } }) => (
                <Stack spacing={1} flexGrow={1}>
                  <RatingBar value={value} onChange={onChange} />
                  {errors.remsQ11?.type === "required" && (
                    <h4 className="error">This field is required</h4>
                  )}
                </Stack>
              )}
            />
          </Box>
        </Stack>
      </Box>
      <Box className="rowQuestionBox">
        <Stack direction={"row"} alignItems="center">
          <Box flexGrow={1}>12. Regular physical activity makes me look better.</Box>
          <Box>
            <Controller
              name="remsQ12"
              control={control}
              rules={{ required: true }}
              render={({ field: { onChange, value, ref } }) => (
                <Stack spacing={1} flexGrow={1}>
                  <RatingBar value={value} onChange={onChange} />
                  {errors.remsQ12?.type === "required" && (
                    <h4 className="error">This field is required</h4>
                  )}
                </Stack>
              )}
            />
          </Box>
        </Stack>
      </Box>
      <Box className="rowQuestionBox">
        <Stack direction={"row"} alignItems="center">
          <Box flexGrow={1}>13. I don't like to overextend myself physically.</Box>
          <Box>
            <Controller
              name="remsQ13"
              control={control}
              rules={{ required: true }}
              render={({ field: { onChange, value, ref } }) => (
                <Stack spacing={1} flexGrow={1}>
                  <RatingBar value={value} onChange={onChange} />
                  {errors.remsQ13?.type === "required" && (
                    <h4 className="error">This field is required</h4>
                  )}
                </Stack>
              )}
            />
          </Box>
        </Stack>
      </Box>
      <Box className="rowQuestionBox">
        <Stack direction={"row"} alignItems="center">
          <Box flexGrow={1}>
            14. I don't have people around who support my interests and efforts.
          </Box>
          <Box>
            <Controller
              name="remsQ14"
              control={control}
              rules={{ required: true }}
              render={({ field: { onChange, value, ref } }) => (
                <Stack spacing={1} flexGrow={1}>
                  <RatingBar value={value} onChange={onChange} />
                  {errors.remsQ14?.type === "required" && (
                    <h4 className="error">This field is required</h4>
                  )}
                </Stack>
              )}
            />
          </Box>
        </Stack>
      </Box>
      <Box className="rowQuestionBox">
        <Stack direction={"row"} alignItems="center">
          <Box flexGrow={1}>15. I avoid physical activity when I can.</Box>
          <Box>
            <Controller
              name="remsQ15"
              control={control}
              rules={{ required: true }}
              render={({ field: { onChange, value, ref } }) => (
                <Stack spacing={1} flexGrow={1}>
                  <RatingBar value={value} onChange={onChange} />
                  {errors.remsQ15?.type === "required" && (
                    <h4 className="error">This field is required</h4>
                  )}
                </Stack>
              )}
            />
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};

export default REMS;
